var _rect, _text, _text2, _text3, _rect2, _circle, _path, _text4, _text5, _rect3, _circle2, _path2, _text6, _text7, _rect4, _circle3, _path3, _text8, _text9, _rect5, _circle4, _path4, _text10, _text11, _rect6, _circle5, _path5, _text12, _text13, _path6, _line, _text14, _rect7, _text15, _text16, _text17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase4Fig3BackstopProof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 600,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The backstop, measured")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The same session that shipped the rule broke it four times, and the detector found every instance.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 120,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "ONE SESSION, FIVE PULL REQUESTS")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 145,
    width: 180,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 174,
    r: 12,
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162,174 l4,4 l8,-9",
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 222,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "PR 1")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 252,
    textAnchor: "middle",
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#16A34A"
  }, "instrumented cycle")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 145,
    width: 180,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 174,
    r: 12,
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379,169 l10,10 M389,169 l-10,10",
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 222,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "PR 2")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 252,
    textAnchor: "middle",
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#DC2626"
  }, "missing cycle")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 145,
    width: 180,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 174,
    r: 12,
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M595,169 l10,10 M605,169 l-10,10",
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 222,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "PR 3")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 252,
    textAnchor: "middle",
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#DC2626"
  }, "missing cycle")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 726,
    y: 145,
    width: 180,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 174,
    r: 12,
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M811,169 l10,10 M821,169 l-10,10",
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 816,
    y: 222,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "PR 4")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 816,
    y: 252,
    textAnchor: "middle",
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#DC2626"
  }, "missing cycle")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 145,
    width: 180,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1032,
    cy: 174,
    r: 12,
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1027,169 l10,10 M1037,169 l-10,10",
    fill: "none",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1032,
    y: 222,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "PR 5")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1032,
    y: 252,
    textAnchor: "middle",
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#DC2626"
  }, "missing cycle")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294,291 v9 H1122 v-9",
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 708,
    y1: 300,
    x2: 708,
    y2: 309,
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 708,
    y: 330,
    textAnchor: "middle",
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#16A34A"
  }, "all 4 flagged by the mechanical coverage detector")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 365,
    width: 1104,
    height: 112,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1,
    strokeDasharray: "6 4"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 399,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "RECORDED CONCLUSION")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 438,
    fontSize: 17,
    fontStyle: "italic",
    fill: "#1A2F2A"
  }, "&#8220;even the author of the discipline did not follow it manually&#8221;")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 552,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Four misses in one session, four detections. The discipline holds because a detector reads the diff.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase4Fig3BackstopProof);
export default __webpack_public_path__ + "static/media/case4-fig3-backstop-proof.cd3974de2dd62b183fc203b18ab1b2ce.svg";
export { ForwardRef as ReactComponent };